import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './switch.scss';

type Props = ComponentPropsWithRef<'input'>;
export const Switch = ({ checked = false, className, ...props }: Props) => {
    return (
        <label className={cn('switch', checked && 'switch--checked')} tabIndex={0}>
            <input type="checkbox" checked={checked} className={cn('switch__input', className)} {...props} />
        </label>
    );
};
